module.exports = __webpack_public_path__ + "img/9788959401956.653c5db4.jpg";